import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function WarrantyDatePicker() {
  return (
    <Field
      type="apiDate"
      name="warrantyDate"
      label={i18n.t('entity.vehicle.labels.warrantyUntil')}
    />
  );
}
